import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { CheckCircle2, Package } from "lucide-react";
import { formatINR } from "../lib/api";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const { state } = useLocation();
  const order = state?.order;

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="order-confirmation-page">
      <CheckCircle2 size={56} strokeWidth={1.3} className="mx-auto text-brand-maroon" />
      <p className="label-tiny text-brand-gold mt-6">Order Confirmed · Namaste</p>
      <h1 className="font-serif-brand text-4xl lg:text-5xl text-brand-charcoal mt-3">Thank you for your order</h1>
      <p className="text-brand-muted mt-3">Your order <span className="text-brand-maroon font-medium">{orderNumber}</span> has been received. A confirmation has been sent to your email and WhatsApp.</p>

      {order && (
        <div className="mt-10 border border-brand-gold/30 bg-brand-ivory-soft p-6 text-left" data-testid="order-summary">
          <div className="flex justify-between pb-4 border-b border-brand-gold/25">
            <div>
              <p className="label-tiny text-brand-gold">Total Paid</p>
              <p className="font-serif-brand text-2xl text-brand-maroon mt-1">{formatINR(order.total)}</p>
            </div>
            <div className="text-right">
              <p className="label-tiny text-brand-gold">Payment</p>
              <p className="mt-1 text-brand-charcoal">{order.payment_method}</p>
            </div>
          </div>
          <p className="label-tiny text-brand-gold mt-6 mb-3">Delivering to</p>
          <p className="text-sm text-brand-charcoal">{order.shipping.full_name}, {order.shipping.line1}, {order.shipping.city} - {order.shipping.pincode}</p>
          <p className="text-xs text-brand-muted mt-1">Phone: {order.shipping.phone}</p>
          <p className="label-tiny text-brand-gold mt-6 mb-3">Estimated Delivery</p>
          <p className="text-sm text-brand-charcoal flex items-center gap-2"><Package size={14} /> 3-7 business days</p>
        </div>
      )}

      <div className="flex flex-wrap justify-center gap-4 mt-10">
        <Link to={`/track-order`} state={{ prefill: orderNumber }} className="btn-outline-gold" data-testid="track-order-cta">Track Order</Link>
        <Link to="/shop" className="btn-primary" data-testid="continue-shopping-cta">Continue Shopping</Link>
      </div>
    </div>
  );
}
